const files = require.context('./', true, /\.js$/i)

const routes = files.keys() // gets all directory urls
    .filter($0 => $0 !== './index.js') // exclude this file from the list of urls
    .map($0 => files($0).default) // executes and read each file
    .filter($0 => Array.isArray($0))
    .reduce(($0, $1) => [...$0, ...$1], [])

export default routes